import { Check } from "lucide-react";
import { dailyRateFeatures, images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function DailyRates() {
  return (
    <section
      id="daily"
      aria-labelledby="daily-rates-heading"
      className="scroll-mt-16 bg-background py-16 md:py-20"
    >
      <div className="shell">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          <Reveal className="order-1 lg:col-span-6 lg:order-none" y={36}>
            <img
              src={images.slider4}
              alt="Daily full-hookup RV site at Auburn RV Resort for overnight stays"
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover md:aspect-[5/6]"
            />
          </Reveal>

          <div className="order-2 lg:col-span-6 lg:order-none">
            <Reveal>
              <Eyebrow>Quick Stops &amp; Weekend Escapes</Eyebrow>
            </Reveal>
            <h2 id="daily-rates-heading" className="display-lg mt-6">
              <MaskReveal>Daily RV Sites</MaskReveal>
            </h2>

            <Reveal delay={0.08}>
              <div className="mt-10">
                <p className="eyebrow text-muted-foreground">From</p>
                <p className="font-display mt-2 text-6xl tracking-tight text-primary md:text-7xl">
                  $85
                </p>
                <p className="mt-2 text-sm uppercase tracking-[0.18em] text-muted-foreground">
                  per night
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.12}>
              <p className="mt-8 max-w-xl text-base leading-relaxed text-muted-foreground">
                Passing through Auburn on your way to your next destination? Daily stays make it
                easy to stop, recharge and enjoy a comfortable full-hookup RV site before the next
                leg of your adventure. Daily RV sites in Auburn CA start at $85.
              </p>
            </Reveal>

            <Reveal delay={0.16}>
              <ul className="mt-8 grid gap-3 sm:grid-cols-2">
                {dailyRateFeatures.map((feature) => (
                  <li key={feature} className="flex items-start gap-3 text-sm text-foreground/85">
                    <span className="mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-full border border-border bg-secondary/50 text-primary">
                      <Check className="size-3.5" strokeWidth={1.6} />
                    </span>
                    <span className="leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={0.2}>
              <p className="mt-8 text-sm text-muted-foreground">
                Rates start at $85 and vary based on lot size, location and availability.
              </p>
              <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
                <ResortLink variant="gold" href="/reservations/" className="w-full sm:w-auto">
                  Check Daily Availability
                </ResortLink>
                <ResortLink variant="outline" href="/accommodations/" className="w-full sm:w-auto">
                  View Accommodations
                </ResortLink>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
